window.refreshCartItemsComponent = async function () {
  try {
    const response = await fetch(window.location.href, {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) throw new Error('Failed to fetch page');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newDrawer = doc.querySelector('cart-drawer-component');
    const currentDrawer = document.querySelector('cart-drawer-component');

    if (!newDrawer || !currentDrawer) {
      console.warn('cart-drawer-component not found.');
      return;
    }

    currentDrawer.replaceWith(newDrawer);

    // Wait for the custom element to upgrade
    await customElements.whenDefined('cart-drawer-component');

    // Wait one frame so connectedCallback has finished
    requestAnimationFrame(() => {
      const drawer = document.querySelector('cart-drawer-component');
      drawer?.open?.(); // or drawer?.showDialog?.();
    });

  } catch (error) {
    console.error('Failed to refresh cart drawer:', error);
  }
};

document.addEventListener('gpoAddedToCart', window.refreshCartItemsComponent);

async function updateCartBubble() {
  try {
    const cart = await fetch('/cart.js').then((r) => r.json());

    document.querySelectorAll('.cart-bubble__text-count').forEach((el) => {
      el.textContent = cart.item_count > 99 ? '' : cart.item_count;
      el.classList.toggle('hidden', cart.item_count === 0);
    });

    document.querySelectorAll('.cart-bubble').forEach((el) => {
      el.classList.toggle('visually-hidden', cart.item_count === 0);
    });

    document.querySelectorAll('cart-icon').forEach((icon) => {
      icon.classList.toggle(
        'header-actions__cart-icon--has-cart',
        cart.item_count > 0
      );
    });
  } catch (e) {
    console.error(e);
  }
}

document.addEventListener("cart:update", updateCartBubble);

/* Globo app - re-select the remembered colour when a Cloth Type tab is re-opened -- Start */

(() => {
  const TAB_INPUT_SELECTOR = '.cloth-color-option input[type="radio"]';
  const GROUP_SELECTOR = '.cloth-sub-color';
  const COLOR_INPUT_SELECTOR = '.cloth-sub-color input[type="radio"]';

  const POLL_INTERVAL = 50;
  const POLL_TIMEOUT = 5000;
  const VERIFY_DELAY = 600; // re-check that a later Globo pass did not wipe our click

  const remembered = new Map(); // group's data-element-id -> chosen value
  let runToken = 0;             // invalidates an in-flight restore if the user switches again

  function isVisible(el) {
    try {
      return !!el && el.isConnected && el.offsetParent !== null
        && getComputedStyle(el).display !== 'none';
    } catch (error) {
      return false;
    }
  }

  function visibleGroup() {
    try {
      return [...document.querySelectorAll(GROUP_SELECTOR)].find(isVisible) || null;
    } catch (error) {
      console.error('[Colour memory] Failed to find the visible group:', error);
      return null;
    }
  }

  function remember(input) {
    try {
      if (!input || !input.checked) return;
      const group = input.closest(GROUP_SELECTOR);
      const key = group && group.dataset ? group.dataset.elementId : null;
      if (!key) return;
      remembered.set(key, input.value);
    } catch (error) {
      console.error('[Colour memory] Failed to remember the selection:', error);
    }
  }

  function labelFor(input) {
    try {
      const id = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(input.id) : input.id;
      return document.querySelector('label[for="' + id + '"]');
    } catch (error) {
      return null;
    }
  }

  function restoreAfterTabSwitch() {
    const token = ++runToken;
    const startedAt = Date.now();

    (function poll() {
      try {
        if (token !== runToken) return;                  // a newer tab switch took over
        if (Date.now() - startedAt > POLL_TIMEOUT) return;

        const group = visibleGroup();
        if (!group) {
          setTimeout(poll, POLL_INTERVAL);
          return;
        }

        const inputs = [...group.querySelectorAll('input[type="radio"]')];
        if (inputs.some((input) => input.disabled)) {    // still settling
          setTimeout(poll, POLL_INTERVAL);
          return;
        }

        const key = group.dataset ? group.dataset.elementId : null;
        const value = key ? remembered.get(key) : undefined;
        if (value === undefined) return;                 // nothing chosen in this tab yet

        const target = inputs.find((input) => input.value === value);
        if (!target || target.checked) return;

        (labelFor(target) || target).click();

        setTimeout(() => {
          try {
            if (token !== runToken) return;
            if (!isVisible(group) || target.checked) return;
            (labelFor(target) || target).click();        // one retry, then leave it alone
          } catch (error) {
            console.error('[Colour memory] Retry failed:', error);
          }
        }, VERIFY_DELAY);
      } catch (error) {
        console.error('[Colour memory] Restore failed:', error);
      }
    })();
  }

  function handleChange(event) {
    try {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;

      if (target.matches(COLOR_INPUT_SELECTOR)) {
        remember(target);
        return;
      }

      if (target.matches(TAB_INPUT_SELECTOR) && target.checked) {
        restoreAfterTabSwitch();
      }
    } catch (error) {
      console.error('[Colour memory] Change handler failed:', error);
    }
  }

  function init() {
    try {
      if (document.documentElement.dataset.colourMemoryInitialised) return;
      document.documentElement.dataset.colourMemoryInitialised = 'true';

      document.querySelectorAll(COLOR_INPUT_SELECTOR).forEach(remember);
      document.addEventListener('change', handleChange);
    } catch (error) {
      console.error('[Colour memory] Initialisation failed:', error);
    }
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  } catch (error) {
    console.error('[Colour memory] Script initialisation failed:', error);
  }
})();

/* Globo app - re-select the remembered colour when a Cloth Type tab is re-opened -- End */
